import * as React from 'react';
import { Icon, Modal } from '../..';

type ModalProps = {
  message: string;
};

function ModalLoader({ message }: ModalProps) {
  return (
    <Modal show>
      <div className="rounded-md bg-white overflow-hidden relative w-[300px] h-[250px] mt-[65%]">
        <div className="p-3 h-full flex flex-col items-center justify-center">
          <div className="text-pos-black font-medium">
            <Icon id="loader" className="w-[50px] h-[50px] mx-auto" />
            <span className="text-pos-black">{message}</span>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ModalLoader;
